import {
  Box,
  Button,
  MenuItem,
  Select,
  TextField,
  useTheme,
} from "@mui/material";

import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useState } from "react";
import { useEffect } from "react";

const columns = [
  {
    id: "typeEnergie",
    label: "Types d’énergie",
    type: "select",
    options: [
      { label: "Electrique", value: "Electrique" },
      { label: "Lié chauffage", value: "Lié chauffage" },
      { label: "Instantanée", value: "Instantanée" },
      { label: "Par accumulations", value: "Par accumulations" },
      { label: "Gaz", value: "Gaz" },
      { label: "Fioul", value: "Fioul" },
    ],
    width: 200,
  },
  {
    id: "capacity",
    label: "Capacité de stockage (en l)",
    type: "number",
  },
  {
    id: "emplacement",
    label: "Emplacement",
    type: "select",
    options: [
      { label: "Volume chauffé", value: "Volume chauffé" },
      { label: "Volume non chauffé", value: "Volume non chauffé" },
    ],
    width: 200,
  },
];

const EcsModal = (props) => {
  const { palette } = useTheme();

  const defaultValue = {};

  let initialValue = defaultValue;

  if (props.initialValue) {
    initialValue = props.initialValue;
  }

  const [ecs, setEcs] = useState(initialValue);
  const [screenSize, setScreenSize] = useState(getCurrentDimension());

  function getCurrentDimension() {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
    };
  }

  useEffect(() => {
    const updateDimension = () => {
      setScreenSize(getCurrentDimension());
    };
    window.addEventListener("resize", updateDimension);

    return () => {
      window.removeEventListener("resize", updateDimension);
    };
  }, [screenSize]);

  const handleChange = (name, value) => {
    let newValue = Object.assign({}, ecs);
    newValue[name] = value;

    setEcs(newValue);
  };

  const submit = () => {
    props.onSubmit(ecs);
  };

  return (
    <Box>
      <Box>
        <Box
          sx={{
            gridColumn: "span 4",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={submit}
            sx={{
              m: "12px",
              p: "10px",
              fontSize: "16px",
              fontWeight: "bold",
            }}
          >
            Enregistrer
          </Button>
        </Box>
        <TableContainer sx={{ maxHeight: screenSize.height - 320 }}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{
                      fontSize: "16px",
                      fontWeight: 600,
                      minWidth: column.minWidth,
                      width: column.width,
                    }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow role="checkbox" tabIndex={-1}>
                {columns.map((column) => {
                  if (column.type === "select") {
                    return (
                      <TableCell
                        sx={{
                          fontSize: "12px",
                          fontWeight: 500,
                          width: column.width,
                          minWidth: column.minWidth,
                        }}
                        key={column.id}
                        align={column.align}
                      >
                        <Select
                          placeholder={column.label}
                          name={column.key}
                          labelId={column.label}
                          id={column.label}
                          value={ecs[column.id]}
                          label={column.label}
                          onChange={(e) =>
                            handleChange(column.id, e.target.value)
                          }
                          sx={{
                            width: column.width,
                            minWidth: column.minWidth,
                          }}
                        >
                          {column.options.map((option, index) => {
                            return (
                              <MenuItem key={index} value={option.value}>
                                {option.label}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </TableCell>
                    );
                  }
                  return (
                    <TableCell
                      sx={{
                        fontSize: "12px",
                        fontWeight: 500,
                        width: column.width,
                        minWidth: column.minWidth,
                      }}
                      key={column.id}
                      align={column.align}
                    >
                      <TextField
                        label={column.label}
                        type="text"
                        //onBlur={handleBlur}
                        onChange={(e) =>
                          handleChange(column.id, e.target.value)
                        }
                        value={ecs[column.id]}
                        name={column.id}
                      />
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default EcsModal;
